import React, { Component } from 'react'
import { connect } from 'react-redux'
import {BestRankingStyle} from './../../styles'

class BestRanking extends Component {
  state = {
    best: 0
  }

  getSup = (sup) => {
    let str = '' 
    switch (sup) {
      case 1:
        str = 'st'
        break;
      case 2:
        str = 'nd'
        break;
      case 3:
        str = 'rd'
        break;
    
      default:
        str = 'th'
        break;
    }

    return str
  }

  render() {
    const { best } = this.props
    return (
      <div className={`best-ranking ${BestRankingStyle} `}>
        <div className="best-ranking-label label">
          Best ranking
        </div>
        <div className="best-ranking-number number">
          { best ? best : '-' }
          { best && <sup> {this.getSup(best) } </sup> }
        </div>
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    best: Session.challenge.best,
  })
)(BestRanking)


// WEBPACK FOOTER //
// ./src/components/Challenge/BestRanking.js